import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import styles from './handle.module.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const Handle = ({ m2sText }) => {
  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.${styles.ctn}`,
        pin: true,
        start: 'top top',
        scrub: 1.5,
        // markers: true,
      },
    });

    tl.to(`.${styles.textBox}`, {
      y: -100,
      opacity: 0,
      duration: 2,
    });

    tl.to(
      `.${styles.p2}`,
      {
        y: 0,
        opacity: 1,
        duration: 2,
      },
      1,
    );

    tl.to(
      `.${styles.img2}`,
      {
        opacity: 1,
      },
      1,
    );
  });
  return (
    <div className={`${styles.ctn} m2s-section fullscreen`}>
      <div className={styles.imgBox}>
        <img
          src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-3-1.jpg"
          alt=""
          className={styles.img}
        />
        <img
          src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-3-2.jpg"
          alt=""
          className={styles.img2}
        />
      </div>
      <div className={styles.textEffectBox}>
        <CircleStyleTextBox className={styles.textBox}>
          <h2
            className={styles.h}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(m2sText['text18']),
            }}
          ></h2>
          <h5
            className={styles.p1}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(m2sText['text19']),
            }}
          ></h5>
        </CircleStyleTextBox>
        <h5 className={styles.p2}             dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(m2sText['text30']),
            }}></h5>
      </div>
    </div>
  );
};

export default Handle;
